import React from 'react';
import { graphql } from 'gatsby';
import { useFelaEnhanced } from '@ackee/fela';
import type { RulesExtend } from '@ackee/fela';

import { LocalizedLink } from 'modules/ui';
import type { PostAuthor } from 'modules/blog/types';

import authorPlaceholder from '../../../../../static/images/blog/author_placeholder.png';
import * as felaRules from './PostAuthorLink.rules';
import { Language, languageSpecificConfig } from '../../../../config/language';

export interface PostAuthorLinkProps {
    author: PostAuthor;
    displayPhoto?: boolean;
    extend?: RulesExtend<typeof felaRules>;
    languageMutation?: Language;
}

export const PostAuthorLink = ({ author, displayPhoto, extend, languageMutation }: PostAuthorLinkProps) => {
    const { styles } = useFelaEnhanced(felaRules, { extend });
    const languagePrefix = languageMutation ? languageSpecificConfig[languageMutation].SITE_URL : '';

    const linkProps = {
        className: styles.link,
        children: displayPhoto ? (
            <div className={styles.container}>
                <img
                    src={author?.photo?.formats?.thumbnail?.url ?? author?.photo?.url ?? authorPlaceholder}
                    alt={author?.displayName}
                    className={styles.photo}
                />
                <span>{author?.displayName}</span>
            </div>
        ) : (
            author?.displayName
        ),
    };

    const pathname = author?.slug ? `/blog/author/${author.slug}` : '/blog';

    if (languageMutation) {
        return <a href={`${languagePrefix}${pathname}`} {...linkProps} />;
    }

    return <LocalizedLink to={`${languagePrefix}${pathname}`} {...linkProps} />;
};

export const authorGraphql = graphql`
    fragment PostAuthor on STRAPI_AUTHOR {
        displayName
        slug
        description
        role
        photo {
            url
            width
            height
            formats {
                thumbnail {
                    url
                    width
                    height
                }
            }
        }
    }
`;
